import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useGoogleAnalyticsConfig = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.GOOGLE_ANALYTICS_CONFIG(),
    queryFn: () => shopApi.fetchGoogleAnalyticsConfig(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.GOOGLE_ANALYTICS_CONFIG(),
    });
  };

  return {
    isLoading,
    isFetching,
    googleAnalyticsConfig: data?.data,
    invalidate,
  };
};
